<button type="button"
        [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate" class="btn"
        [routerLink]="url">
  <fa-icon [icon]="faEdit"></fa-icon>
</button>
